import type { SwipeTone } from "@scribenote/brian-design-system";

import type { CaptureNode } from "./captureClient";

type CaptureStatus = "recording" | "online" | "offline" | "stale";

/** Offline is unmarked: a device switched off is a fact, not an alarm. */
export const STATUS_WORD: Record<
  CaptureStatus,
  { label: string; tone: SwipeTone | null }
> = {
  recording: { label: "Recording", tone: "working" },
  online: { label: "Online", tone: "working" },
  offline: { label: "Offline", tone: null },
  stale: { label: "Unknown - link down", tone: "flag" },
};

export const statusForNode = (node: CaptureNode): CaptureStatus => {
  // A down connector leaves online/recording untrustworthy.
  if (!node.connectorLive) return "stale";
  if (node.recording) return "recording";
  if (node.online) return "online";
  return "offline";
};

export const nodesByRoom = (
  nodes: CaptureNode[],
): Map<string, CaptureNode[]> => {
  const byRoom = new Map<string, CaptureNode[]>();
  for (const node of nodes) {
    if (!node.roomUuid) continue;
    const list = byRoom.get(node.roomUuid);
    if (list) list.push(node);
    else byRoom.set(node.roomUuid, [node]);
  }
  return byRoom;
};
